import { useEffect, useState } from "react";

// MSAL imports
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import {
  InteractionStatus,
  InteractionType,
  InteractionRequiredAuthError,
  AccountInfo,
} from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

// App imports
import { ProfileData, GraphData } from "../ui-components/ProfileData";
import { Loading } from "../ui-components/Loading";
import { ErrorComponent } from "../ui-components/ErrorComponent";
import { callMsGraph } from "../utils/MsGraphApiCall";

const ProfileContent = () => {
  const { instance, inProgress } = useMsal();
  const [graphData, setGraphData] = useState<null | GraphData>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!graphData && inProgress === InteractionStatus.None) {
      callMsGraph()
        .then((response) => setGraphData(response))
        .catch((e) => {
          if (e instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect({
              ...loginRequest,
              account: instance.getActiveAccount() as AccountInfo,
            });
          } else {
            setError(e.message || "Failed to fetch profile data");
          }
        });
    }
  }, [inProgress, graphData, instance]);

  if (error) {
    return (
      <div className="w-full max-w-lg">
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <div className="bg-red-50 border-l-4 border-red-500 p-6">
            <p className="text-red-700 font-medium">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-lg">
      <div className="card overflow-hidden">
        <div className="gradient-header px-6 py-5">
          <h2 className="text-white text-xl font-semibold">Your Profile</h2>
          <p className="text-blue-100 text-sm mt-1">
            Information from Microsoft Graph
          </p>
        </div>
        <div className="p-6">
          {graphData ? (
            <ProfileData graphData={graphData} />
          ) : (
            <div className="flex justify-center py-8">
              <div className="w-8 h-8 border-4 border-wmp-100 border-t-wmp-500 rounded-full animate-spin" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export function Profile() {
  const authRequest = {
    ...loginRequest,
  };

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <ProfileContent />
    </MsalAuthenticationTemplate>
  );
}
